import { create } from 'zustand';
import fetchWithTenant from '../utils/fetchWithTenant';

const useCcmLicenseStore = create((set) => ({
  license: null,
  loading: true,
  error: null,

  fetchLicense: async () => {
    set({ loading: true, error: null });
    try {
      const res = await fetchWithTenant('/api/ccm/license');
      if (res.ok) {
        const data = await res.json();
        set({ license: data, loading: false });
      } else {
        set({ license: null, loading: false, error: `HTTP ${res.status}` });
      }
    } catch (err) {
      console.error('[CcmLicense] Fetch failed:', err);
      set({ license: null, loading: false, error: err.message });
    }
  },

  clearLicense: () => set({ license: null, loading: true, error: null }),
}));

export default useCcmLicenseStore;
